import httpClient from '@/api/httpClient';

const getSerumInciList = (treatmentId, deliveryCountry) => {
  return httpClient.get(`/api/webShop/inci/${treatmentId}/country/${deliveryCountry}`);
};

const getTreatment = treatmentId =>
  httpClient.get(`/api/webShop/${treatmentId}/products/filledTreatment`);

const getPrototypeTreatmentDataByCurrentTreatmentId = treatmentId =>
  httpClient.get(`/api/webShop/${treatmentId}/prototypeChart`);

const getRecommendedProducts = treatmentId =>
  httpClient.get(`/api/webShop/${treatmentId}/products/label`);

const getValidationPageData = treatmentId =>
  httpClient.get(`/api/webShop/${treatmentId}/validationData`);

const getDeliveryData = treatment => httpClient.post(`/api/webShop/showDeliveryCost`, treatment);

const getAvailableDeliveryCountries = treatment =>
  httpClient.post('/api/webShop/showAvailableDestinations', treatment);

const getEyeContourGenericFormulas = treatment =>
  httpClient.post(`/api/webShop/genericEyeContourRecommendation`, treatment);

const setOfferViewed = treatment => httpClient.post('/api/webShop/offerViewed', treatment);

export {
  getSerumInciList,
  getTreatment,
  getRecommendedProducts,
  getValidationPageData,
  getDeliveryData,
  getPrototypeTreatmentDataByCurrentTreatmentId,
  getAvailableDeliveryCountries,
  getEyeContourGenericFormulas,
  setOfferViewed
};
